/* sb-standards.js — ONE job for the Standards band, observer-driven.

   THE ENTRANCES (all widths).
   The head and the three frosted cards arrive with their own choreography. They are
   deliberately NOT .sb-reveal: theme.liquid force-reveals every .sb-reveal 2.5s after
   load as a safety net, and this band sits far below the fold, so the net always won —
   every entrance was finished long before anyone scrolled here. Instead this script
   arms the section (.is-armed — the CSS zero state exists only under that class, so
   no-JS / no-IntersectionObserver / reduced-motion users never see hidden content) and
   marks each element .is-seen from its own one-shot observer. Elements already on
   screen at arm time (scroll restoration, bfcache, theme-editor re-renders) are
   pre-marked so arming never blanks visible content.

   THE HEADER STAYS (owner direction 2026-08-12). This script used to slide the
   always-sticky header away while the band held the phone screen (the sb-header-away
   mechanic, shared with the PDP problem passage in sb-problem.js — which KEEPS it).
   Retired here: the band now flips the header's contrast instead — the image panel
   carries color-scheme-2, so the header's own brightness sampler (sections/
   header.liquid) turns the nav white over the photograph, the same adaptive swap the
   rest of the site uses. If the slide-away ever returns, recover armHeader() from
   git history or mirror sb-problem.js. */
(function () {
  'use strict';

  if (window.__sbStandards) return;
  window.__sbStandards = true;

  var REDUCE = '(prefers-reduced-motion: reduce)';
  var entranceIOs = [];

  function teardownEntrance() {
    while (entranceIOs.length) entranceIOs.pop().disconnect();
    Array.prototype.forEach.call(document.querySelectorAll('.sb-standards.is-armed'), function (sec) {
      sec.classList.remove('is-armed');
    });
  }

  function armEntrance(root) {
    teardownEntrance();
    /* Capability + preference verified BEFORE any zero state can exist. */
    if (!window.IntersectionObserver || !window.matchMedia) return;
    if (window.matchMedia(REDUCE).matches) return;

    var sections = (root || document).querySelectorAll('.sb-standards');
    Array.prototype.forEach.call(sections, function (sec) {
      var targets = sec.querySelectorAll('.sb-standards__head, .sb-standards__card');
      if (!targets.length) return;

      /* Pre-mark anything already on screen, then arm — in that order, so the
         armed zero state can never blank content the user is looking at. */
      var vh = window.innerHeight || document.documentElement.clientHeight;
      Array.prototype.forEach.call(targets, function (t) {
        var r = t.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) t.classList.add('is-seen');
      });
      sec.classList.add('is-armed');

      /* One-shot per element: is-seen sticks, so nothing ever re-hides on an
         upward scroll and nothing races the theme's global reveal net. */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-seen');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
      Array.prototype.forEach.call(targets, function (t) {
        if (!t.classList.contains('is-seen')) io.observe(t);
      });
      entranceIOs.push(io);
    });
  }

  /* ── wiring ───────────────────────────────────────────────────────────── */

  function start() { armEntrance(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* The entrances are motion-gated, so a live reduced-motion flip has to
     re-decide — and put everything back to safe on the way out. */
  if (window.matchMedia) {
    var mq = window.matchMedia(REDUCE);
    var onChange = function () { armEntrance(document); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  /* Theme editor: sections re-render without a page load. */
  document.addEventListener('shopify:section:load', function () { armEntrance(document); });
  document.addEventListener('shopify:section:unload', function () { armEntrance(document); });
})();
